<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Insurance'"
      [canGoBack]="true"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [hasBottomNav]="true">
    <insurance-content />
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />

<tidy-bottom-nav activeRoute="/insurance" />
